import { LitElement, html, css } from "lit";
import { customElement } from "lit/decorators.js";

import "../components/auto-header";
import "../components/auto-nav";
import "../components/auto-footer";

@customElement("auto-about")
export class AutoAbout extends LitElement {
  static styles = css`
    main {
      margin: 0;
      padding: 8px 16px;
    }
  `;

  render() {
    return html`
      <auto-header title="AUTO / par"></auto-header>
      <auto-nav></auto-nav>
      <main>
        <p>Versija 0.0.101</p>
        <p>
          Privāts projekts, savam priekam, primāri kā tehnoloģiju eksperiments.
          Ja Tev noder, tad par to man tikai prieks.
        </p>
        <p>
          CSDD UZSKAITĒ esoši automobīļi uz <strong>24.02.2025.</strong> datumu.
          Izskatās, ka CSDD publicē savus datus reizi gadā, kad planētas
          sastājas pareizā, tikai viņiem zināmā, stāvoklī. Tāpēc, ja Tev liekas,
          ka kāda auto nav datos, varbūt bija noņemts no uzskaites uz ziemu,
          varbūt datu failā kļūda, utt... jebkurā gadījumā par datu precizitāti
          neatbildu.
        </p>
        <p>
          <a
            href="https://data.gov.lv/dati/lv/dataset/transportlidzeklu-registracijas/resource/96ca9430-f4df-4d2a-b17b-ba865d8a5b54"
            >Dati</a
          >
          iegūti no
          <a href="https://data.gov.lv/lv">Latvijas atvērto datu portāla</a>.
        </p>
      </main>
      <auto-footer></auto-footer>
    `;
  }
}
